namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_book_widgets3, {

		Head: {
			justify: {
				content: 'flex-start',
			},
		},

		Body: {
			overflow: {
				x: 'hidden',
			},
		},

		Tree: {
			width: '100%',
		},

		Removed_widgets: {
			width: '100%',
		},

		Widget_item: {
			width: '100%',
			'[selected]': {
				true: {
					['Widget_title_button' as '$mol_view']: {
						color: $mol_theme.current,
						textShadow: '0 0',
					},
					['Widget_title_input']: {
						color: $mol_theme.current,
						textShadow: '0 0',
					} as any,
				},
			},
		},

		Editor_widget_item: {
			width: '100%',
		},

		Editor_widget_line: {
			width: '100%',
		},

		Removed_widget_item: {
			width: '100%',
			':hover': {
				['Widget_restore' as '$mol_view']: {
					display: 'flex',
					opacity: 1,
				},
			},
		},

		Removed_widget_line: {
			position: 'relative',
			width: '100%',
			alignItems: 'flex-start',
		},

		Removed_widget_title: {
			flex: {
				grow: 1,
				shrink: 1,
			},
			width: '100%',
			minWidth: 0,
			gap: '0.5rem',
			opacity: 0.2,
			padding: {
				left: '0.5rem',
				right: 0,
				top: '0.5rem',
				bottom: '0.5rem',
			},
		},

		Widget_restore: {
			display: 'none',
			position: 'absolute',
			right: 0,
			top: '50%',
			transform: 'translateY(-50%)',
			zIndex: $mol_layer.float,
			flex: {
				shrink: 0,
			},
		},

		Widget_title_button: {
			width: '100%',
			minWidth: 0,
			justifyContent: 'flex-start',
			gap: '0.5rem',
			padding: {
				left: '0.5rem',
				right: 0,
				top: '0.5rem',
				bottom: '0.5rem',
			},
		},

		Widget_link: {
			width: '100%',
			minWidth: 0,
			justifyContent: 'flex-start',
			gap: '0.5rem',
			padding: {
				left: '0.5rem',
				right: 0,
				top: '0.5rem',
				bottom: '0.5rem',
			},
		},

		Widget_title_input: {
			width: '100%',
		},

		Widget_icon: {
			flex: {
				shrink: 0,
			},
			opacity: 0.5,
		},

		Widget_title_text: {
			display: 'block',
			flex: {
				grow: 1,
				shrink: 1,
			},
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},

		Widget_title: {
			flex: {
				grow: 1,
				shrink: 1,
			},
			width: '100%',
			minWidth: 0,
		},

	} )

}
